import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form', 'notification']

  done(event) {
    this.formTarget.style = 'display: none'
    this.notificationTarget.style = 'display: block'
  }
}
